import { Collapse } from 'antd';
import { ReactComponent as AreaIcon } from '@features/regional-overview/assets/components/area-icon.svg';
import { ReactComponent as ExpandMoreIcon } from '@features/regional-overview/assets/components/expand-more-icon.svg';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const StyledCollapse = styled(Collapse)`
  background-color: transparent;
  border: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;

  && .ant-collapse-item {
    border: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
    border-radius: 8px;
    overflow: hidden;
  }

  &&& .ant-collapse-header {
    align-items: flex-start;
    padding: 12px 16px;
    background-color: ${COLOR_OPTIONS.WHITE};
    gap: 8px;
    border-radius: 8px;
  }

  &&&& .ant-collapse-expand-icon {
    align-self: flex-start;
    order: 1;
    margin-inline-end: 0;
  }

  && .ant-collapse-title {
    min-width: 0;
    flex: 1;
  }

  &&& .ant-collapse-panel {
    border-top: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
    background-color: ${COLOR_OPTIONS.NEUTRAL_20};
  }

  && .ant-collapse-body {
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: ${COLOR_OPTIONS.NEUTRAL_10};
  }
`;

export const CardHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: nowrap;
`;

export const FarmName = styled.div`
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
`;

export const FieldCount = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${COLOR_OPTIONS.NEUTRAL_60};
  flex-shrink: 0;
`;

export const FieldCountIcon = styled(AreaIcon)`
  width: 16px;
  height: 16px;

  path {
    fill: ${COLOR_OPTIONS.NEUTRAL_60};
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const ExpandIcon = styled(ExpandMoreIcon)<{ isActive: boolean }>`
  color: ${COLOR_OPTIONS.NEUTRAL_80};
  width: 18px;
  height: 18px;

  transform: ${({ isActive }) => (isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
